<template>
    <div class="radio">
        <input 
            :name="name"
            :id="name + value"
            :checked="isChecked"
            type="radio" 
            @click="onClick"
        />
        <label 
            :for="name + value"
            class="text-upper fs-18"
            v-text="label" 
        />
    </div>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        value: {
            type: [String, Number],
            required: true
        },
        isChecked: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    methods: {
        onClick() {
            this.$emit('click', this.value)
        }
    }
}
</script>

<style lang="scss">
.radio {
    display: inline-block;
    vertical-align: middle;

    & + & {
        margin-left: 30px;
    }

    > input {
        opacity: 0;

        &:checked + label {
            &:after {
                @include show();
                @include transform-none();
            }
        }
    }

    > label {
        cursor: pointer;
        position: relative;
        padding-left: 6px;

        &:before {
            content: '';
            @include size(14px);
            @include border-circle();
            background-color: $color-bg-light;
            border: 1px solid $color-bg-dark;
            position: absolute;
            left: -14px;
            top: 5px;
        }

        &:after {
            content: '';
            @include size(8px);
            @include border-circle();
            @include transform(scale(.618));
            @include transition(.150s);
            background-color: $color-primary;
            position: absolute;
            left: -11px;
            top: 8px;         
            opacity: 0;
        }

        &:hover {
            &:after {
                @include transform(scale(2.5));
                opacity: .2;
            }
        }
    }
}
</style>
